<!--
	its frontend

	Page, submodule from App

    @file         Page_hello.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>
    import { PAGE }                 from './config';
    import { URL_API, URL_IMG, stopClickPropagation } 	from './minions';

    import {createEventDispatcher}  from "svelte";
    let dispatch =  createEventDispatcher();



// ============================ store variables ==============================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
        login = value;
    });


// ======================== Image upload and display =========================


    let imageFilename;
    let imgElem;
    let imgSrc;


    const imageUpload = async ()=> {

        let pa = document.getElementById("imageUploadDOMEl");

        pa.onchange = async evt=> {

            let file = evt.target.files[0];
            if (file) {
                const formImg = new FormData();
                formImg.append('imageFile', file);
                formImg.append('jsonStr', JSON.stringify({...login}));

                const reply = await fetch(URL_API("upload_image"), {
                            method:'post',
                            body: formImg
                        })
                    .catch( err=> {
                        console.log('image upload failed')
                    });

                if (reply && reply.ok) {

                    const data = await reply.json();
                    imageFilename = data["imageFilename"];
                    imgSrc = URL_IMG(imageFilename.replace('.jpg','_proc.jpg'));

                }
                else {
                    dispatch('message', {text: "Faild to connect to server."});
                }
            }
        }

        pa.click();


    };//imageUpload()



// ============================= Probe selection =============================


    let spMd = ["Single", "Line", "Grid"]
    let samplingMode = 0;
    let samplingRows = 7;
    let samplingCols = 7;
    let samplingHint = ["Please click in image the location you like to probe.",
                        "Please click first and last location you like to probe.",
                        "Please click the 4 corner locations."]
    let samplingCorners = []

    let prOr = ["Horizontal", "Vertical"]
    let probeOrientation = 1;
    let probeHeight_px = 81;
    let probeWidth_px = 51;

    let selectedProbe = 0;
    let snrData = [];
    let plotsDensi = [];

    let be_busy = false;
    let profiles_ready = false;

    
    //=>
    const iterateSamplingMode = ()=> { 
        samplingMode=(samplingMode + 1) % 3;
        // Clean up
        resetImgMarker();
        selectedProbe = 0;
        snrData = [];
        plotsDensi = [];
        profiles_ready = false;
        imgSrc = URL_IMG(imageFilename.replace('.jpg','_proc.jpg'));
    };//iterateSamplingMode()


    //=>
    const resetImgMarker = ()=> { 
        samplingCorners = [];

        let marker = document.getElementsByClassName('imgMarker');
        Array.from(marker).forEach(marker=> {
            marker.style.display = 'none'; 
        })        
        // for (let idx = 1; idx < 5; idx++) {
        //     let marker = document.getElementById('marker' + idx);
        //     marker.style.display = 'none';            
        // }
    };//resetImgMarker()
    

    

    //=>
    const plateImgClick = async evt => { 

        if(be_busy || !imgElem) {
            return;
        }
        be_busy = true;

        stopClickPropagation(evt);

        // Relative coordinates in image for backend
        let imgRect = imgElem.getBoundingClientRect();
        let xPosRel = (evt.clientX - imgRect.left) / imgRect.width;
        let yPosRel = (evt.clientY - imgRect.top) / imgRect.height;
        samplingCorners.push([xPosRel, yPosRel])

        // console.log(`Rel x pos: ${xPosRel}, Rel y pos: ${yPosRel}; evt.clientX: ${evt.clientX}, evt.clientY: ${evt.clientY}`);

        // Show markers
        let marker = document.getElementById('marker' + samplingCorners.length);
        marker.style.left = evt.pageX - 20 + 'px';
        marker.style.top  = evt.pageY - 20 + 'px';
        marker.style.display = 'block';

        // If all markers for sampling mode given -> evaluate
        if ( (samplingMode === 0) ||
             (samplingMode === 1 && samplingCorners.length === 2) ||
             (samplingMode === 2 && samplingCorners.length === 4)){
            await requestEvaluation();
        }
        
        be_busy = false;

        
    };//plateImgClick()
    

    //=>
    const requestEvaluation = async ()=> {

        const reply = await fetch(URL_API("benma/probe_snr"), {
                method:'post',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    ...login, 
                    imageFilename: imageFilename,
                    samplingCorners: samplingCorners,
                    samplingRows: samplingRows,
                    samplingCols: samplingCols,
                    probeOrientation: prOr[probeOrientation],
                    probeHeight_px: probeHeight_px,
                    probeWidth_px: probeWidth_px
                }
                )});

        if (reply && reply.ok) {
            const data = await reply.json();

            // show image with rois
            imgSrc = URL_IMG(data.imageFilename);

            // List of signal to noise ratio for all samples
            snrData = data.snrData;
            
            // Plot densitogram of first sample in list

            plotsDensi = data.plots;

            selectProbe(0);

            profiles_ready = true;
        }
        else {
            console.log('probe SNR failed');
        }

        resetImgMarker();
        be_busy = false;

    };//requestEvaluation()
    


    //=>
    const selectProbe = probeIndex => { 
        selectedProbe = probeIndex;

        Plotly.newPlot('plotDensi', plotsDensi[selectedProbe]);

        const imgRect = imgElem.getBoundingClientRect();
        // ! The displayed images has half the resolution of the original, for which the x and y coordinates were calculated
        const xPosRel = snrData[selectedProbe].centerX / (2*imgElem.naturalWidth);
        const yPosRel = snrData[selectedProbe].centerY / (2*imgElem.naturalHeight);

        let xMarker = imgElem.offsetLeft + xPosRel * imgRect.width;
        let yMarker = imgElem.offsetTop + yPosRel * imgRect.height;

        let marker = document.getElementById('markerActive');
        marker.style.left = xMarker - 30 + 'px';
        marker.style.top  = yMarker - 30 + 'px';
        marker.style.display = 'block';

    };//selectProbe()
    


// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {
        imgElem = document.getElementById('plateImg');
        imgElem.addEventListener('click', plateImgClick);
    });//onMount()


    function close(nextPage=PAGE.home) {
        dispatch('close', {page: nextPage});
    }//close()


    onDestroy(async () => {

    });//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->




<div class="page">

    <h1>Benchmark</h1>

    <h3>SNR & LOD</h3>

    <div class="btn" on:click={imageUpload}>
        Upload an image
    </div>

    <!-- Show uploaded image, incl. marker of regions used for analysis -->
    {#if imgSrc}

    <div class="plotHeaderRow">
        <div class="box-input">
            <label for="btn_samplingMode">Sampling mode</label>
            <div class="btn" on:click={iterateSamplingMode}>
                {spMd[samplingMode]}
            </div>
        </div>        
        {#if samplingMode > 0 }            
        <div class="box-input">
            <label for="num_samplingCols">Samplings columns</label>
            <input id="num_samplingCols" class="input-txt"
                bind:value={samplingCols} 
                type="number" min="1" max="20" pattern="\d*">
        </div>
        {/if}
        {#if samplingMode > 1}
        <div class="box-input">
            <label for="num_samplingRows">Samplings rows</label>
            <input id="num_samplingRows" class="input-txt"
                bind:value={samplingRows} 
                type="number" min="1" max="20" pattern="\d*">
        </div>
        {/if}
    </div>
    <div class="plotHeaderRow">

        <div class="box-input">
            <label for="btn_probeOrient">Probe orientation</label>
            <div class="btn" on:click={()=>probeOrientation=(probeOrientation + 1) % 2}>
                {prOr[probeOrientation]}
            </div>
        </div>
        <div class="box-input">
            <label for="num_probeHeigth">Probe height in pixel</label>
            <input id="num_probeHeigth" class="input-txt"
                bind:value={probeHeight_px} 
                type="number" min="31" max="100" pattern="\d*">
        </div>
        <div class="box-input">
            <label for="num_probeWidth">Probe width in pixel</label>
            <input id="num_probeWidth" class="input-txt"
                bind:value={probeWidth_px} 
                type="number" min="31" max="100" pattern="\d*">
        </div>
    </div>

    {/if}
    
    <div class="box" class:hide={!imgSrc}>
        <p class="info">{samplingHint[samplingMode]}</p>

        <img id="plateImg" src={imgSrc} alt="">
   
        <div id="marker1" class="imgMarker" ></div> 
        <div id="marker2" class="imgMarker" ></div>
        <div id="marker3" class="imgMarker" ></div>
        <div id="marker4" class="imgMarker" ></div>
        <div id="markerActive" class="imgMarker active" ></div>
    </div>

    <div class="box" class:hide={!profiles_ready}>
        <div class="plot" id="plotDensi"></div>
    </div>

    {#if snrData.length > 0}
    <table>
        <tr>
            <th>Col</th>
            <th>Row</th>
            <th>Position</th>
            <th>Channel</th>
            <th>Peak SNR</th>
            <th>Peak value</th>
            <th>Backg. mean</th>
            <th>Backg. std</th>
        </tr>
        {#each snrData as snrItem, idx}
            <tr class="probeTableRow" class:activeRow={idx==selectedProbe}
                on:click={()=> selectProbe(idx)}>
                <td rowspan="5"> {snrItem.col} </td>
                <td rowspan="5"> {snrItem.row} </td>
                <td rowspan="5"> x: {snrItem.centerX} px<br>y: {snrItem.centerY} px </td>
            </tr>
            
            {#each snrItem["channels"] as channel}                    
            <tr>
                <td>{channel.name}</td>
                <td>{channel.peak_std.toFixed(3)}</td>
                <td>{channel.peakMaxValue.toFixed(1)}</td>
                <td>{channel.backgroundMean.toFixed(1)}</td>
                <td>{channel.backgroundStd.toFixed(3)}</td>
            </tr>
            {/each}
        {/each}
    </table>
    {/if}




</div>

<input id="imageUploadDOMEl" name="imageFile" type="file" accept="image/jpeg"  style="display:none;"/>



<!-- ============================  S T Y L E  ============================ -->



<style>
	.page {
        width: 100%;
        max-width: 1200px;
        margin-top: 2em;
        margin-left: auto;
        margin-right: auto;
        padding: 2em;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        margin-top: 3em;
    }

    h3 {
        border-top: 1px solid var(--tF-gray);
        padding: 1em 2em;
        margin: 1em auto;
    }

    .btn {
        width: 20em;
    }

    .box {
        margin-top: 3em;
        width: 100%;
        max-width: 1400px;
    }

    .box img{
        width: 100%;
        max-width: 1200px;
        object-fit: contain;
        cursor: crosshair;
    }

    .plot {
        width: 100%;
        min-height: 800px;
        overflow: hidden;
        margin-bottom: 3em;
        margin-left: 0px;
    }

    .plotHeaderRow {
        margin-top: 2em;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0.5em;
        align-items: flex-end;
    }

    .info{
        margin-bottom: 1em;
    }

    .imgMarker{
        display: none;
        width: 41px;
        height: 41px;
        border-radius: 50%;
        border: 1px solid red;
        background-color: rgba(160, 0, 32, 0.4);
        position: absolute;
        z-index: 100;
    }
    .imgMarker.active {
        width: 61px;
        height: 61px;
        border: 2px solid red;
        background-color: rgba(160, 0, 32, 0.0);
    }

    .probeTableRow{
        border-bottom: 2px solid black;
        user-select: none;
    }

    .activeRow {
        background-color: var(--tF-blue);
        color: white;
    }
</style>